import React from "react";
import { CodeBlock } from "react-code-block";
import { useCopyToClipboard } from "react-use";
import "@fortawesome/fontawesome-svg-core/styles.css";
import YouTube from "react-youtube";

function LegoL99FeatureComponent({ code, language }) {
  code = `{/* L99 Feature variant (l099Feature): larger image + non-italic copy.
    Add "l099Feature" alongside "l099". Use p.descriptionHeader for a bold,
    non-italic heading. Image widens to ~45% and copy is set non-italic. */}
<div className="lego l099 l099Feature legoMargin5">
    <div className="legoContainer">
        <div className="imgContainer">
            <a target="_blank" rel="noreferrer" href="<RESOURCE_URL>">
                <img className="" alt="<ALT>" src="<IMAGE_URL>" />
            </a>
        </div>
        <div className="contentContainer">
            <p className="descriptionHeader">Heading goes here</p>
            <p>
                Body copy with an inline{" "}
                <a className="blueLinkfont22" target="_blank" rel="noreferrer" href="<RESOURCE_URL>">link</a>{" "}
                that opens in a new tab.
            </p>
        </div>
    </div>
</div>
{/* End L99 Feature variant */}`;
  language = "jsx";
  const [state, copyToClipboard] = useCopyToClipboard();

  const copyCode = () => {
    copyToClipboard(code);
  };

  return (
    <CodeBlock code={code} language={language}>
      <div className="relative">
        <CodeBlock.Code className="bg-black">
          <div className="table-row">
            <CodeBlock.LineNumber className="table-cell pr-4 text-sm text-gray-500 text-right select-none" />
            <CodeBlock.LineContent className="table-cell">
              <CodeBlock.Token />
            </CodeBlock.LineContent>
          </div>
        </CodeBlock.Code>
        <div className="buttonContainer">
          <button className="btn btn-primary ml-auto" onClick={copyCode}>
            <i className="fa-solid fa-copy"></i>{" "}
            {state.value ? "Copied!" : "Copy code"}
          </button>
        </div>
      </div>
    </CodeBlock>
  );
}

export default LegoL99FeatureComponent;
